import React from 'react'
import PropTypes from 'prop-types'

const dispNone = {
  display: 'none'
}

const routingToolMarkup = props => {

  return (
    <div className="row">
      <div className={`component plain-html col-12 routing-tool ${props.swap && 'routing-tool--swap'}`}>
        <div className="component-content">
          <div className="routing-tool__content">
            <div className="routing-tool__image">
              <img className="is-shown" src="https://www.zurich.com/-/media/Project/zurich/dotcom/home/images/stage-individual.jpg" alt="" width="2500" height="1250" />
              <img className="lazy" data-src="https://www.zurich.com/-/media/Project/zurich/dotcom/home/images/stage-company.jpg" alt=""
                   src="" width="2500" height="1250" />
            </div>
            <div className={`routing-tool__copy is-shown ${props.theme.length > 0 ? 'routing-tool__copy--' + props.theme : ''}`}>
              <h1>Welcome to the Zurich Group</h1>
              <p>Visit the country website for your region</p>
            </div>
          </div>
          <div className="routing-tool__toggle">
            <div className="routing-tool__choose">
              <div className="routing-tool__head">
                <button className="routing-tool__action is-active">
                  <span className="icon icon--account"></span> Individual
                </button>
                {!props.single &&
                  <button className="routing-tool__action">
                    <span className="icon icon--industry"></span> Company
                  </button>
                }
              </div>
              <div className="routing-tool__body">
                <form className="routing-tool__form is-visible">
                  <h4 className="routing-tool__headline">
                    Please fill in for customer support, claims or products
                  </h4>
                  <fieldset className="form-group is-active">
                    <label htmlFor="routingLocatedCustom">i'm located in</label>
                    <div className="js-Dropdown" id="custom-routingLocatedCustom">
                      <button className="js-Dropdown-title flag flag--de">Germany</button>
                      <ul className="js-Dropdown-list">
                        <li data-value="ar" data-index="0" className="flag flag--ar">Argentina</li>
                        <li data-value="au" data-index="1" className="flag flag--au">Australia</li>
                        <li data-value="at" data-index="2" className="flag flag--at">Austria</li>
                        <li data-value="bh" data-index="3" className="flag flag--bh">Kingdom of Bahrain</li>
                        <li data-value="be" data-index="4" className="flag flag--be">Belgium</li>
                        <li data-value="br" data-index="5" className="flag flag--br">Brazil</li>
                        <li data-value="ca" data-index="6" className="flag flag--ca">Canada</li>
                        <li data-value="cl" data-index="7" className="flag flag--cl">Chile</li>
                        <li data-value="cn" data-index="8" className="flag flag--cn">China</li>
                        <li data-value="co" data-index="9" className="flag flag--co">Colombia</li>
                        <li data-value="ec" data-index="10" className="flag flag--ec">Ecuador</li>
                        <li data-value="fi" data-index="11" className="flag flag--fi">Finland</li>
                        <li data-value="fr" data-index="12" className="flag flag--fr">France</li>
                        <li data-value="de" data-index="13" className="flag flag--de is-selected">Germany</li>
                        <li data-value="hk" data-index="14" className="flag flag--hk">Hong Kong</li>
                        <li data-value="id" data-index="15" className="flag flag--id">Indonesia</li>
                        <li data-value="ie" data-index="16" className="flag flag--ie">Ireland</li>
                        <li data-value="it" data-index="17" className="flag flag--it">Italy</li>
                        <li data-value="jp" data-index="18" className="flag flag--jp">Japan</li>
                        <li data-value="kw" data-index="19" className="flag flag--kw">Kuwait</li>
                        <li data-value="lb" data-index="20" className="flag flag--lb">Lebanon</li>
                        <li data-value="li" data-index="21" className="flag flag--li">Liechtenstein</li>
                        <li data-value="lu" data-index="22" className="flag flag--lu">Luxembourg</li>
                        <li data-value="my" data-index="23" className="flag flag--my">Malaysia</li>
                        <li data-value="mx" data-index="24" className="flag flag--mx">Mexico</li>
                        <li data-value="nl" data-index="25" className="flag flag--nl">Netherlands</li>
                        <li data-value="nz" data-index="26" className="flag flag--nz">New Zealand</li>
                        <li data-value="no" data-index="27" className="flag flag--no">Norway</li>
                        <li data-value="om" data-index="28" className="flag flag--om">Oman</li>
                        <li data-value="pt" data-index="29" className="flag flag--pt">Portugal</li>
                        <li data-value="qa" data-index="30" className="flag flag--qa">Qatar</li>
                        <li data-value="ru" data-index="31" className="flag flag--ru">Russia</li>
                        <li data-value="sg" data-index="32" className="flag flag--sg">Singapore</li>
                        <li data-value="es" data-index="33" className="flag flag--es">Spain</li>
                        <li data-value="se" data-index="34" className="flag flag--se">Sweden</li>
                        <li data-value="ch" data-index="35" className="flag flag--ch">Switzerland</li>
                        <li data-value="tr" data-index="36" className="flag flag--tr">Turkey</li>
                        <li data-value="gb" data-index="37" className="flag flag--gb">United Kingdom</li>
                        <li data-value="ae" data-index="38" className="flag flag--ae">United Arab Emirates</li>
                        <li data-value="us" data-index="39" className="flag flag--us">United States</li>
                        <li data-value="ve" data-index="40" className="flag flag--ve">Venezuela</li>
                        <li data-value="sk" data-index="41" className="flag flag--sk">Slovakia</li>
                        <li data-value="tw" data-index="42" className="flag flag--tw">Taiwan</li>
                      </ul>
                    </div>
                    <select id="routingLocatedCustom" className="custom-select flag flag--de" style={dispNone}>

                      <option value="ar" className="flag flag--ar">Argentina</option>
                      <option value="au" className="flag flag--au">Australia</option>
                      <option value="at" className="flag flag--at">Austria</option>
                      <option value="bh" className="flag flag--bh">Kingdom of Bahrain</option>
                      <option value="be" className="flag flag--be">Belgium</option>
                      <option value="br" className="flag flag--br">Brazil</option>
                      <option value="ca" className="flag flag--ca">Canada</option>
                      <option value="cl" className="flag flag--cl">Chile</option>
                      <option value="cn" className="flag flag--cn">China</option>
                      <option value="co" className="flag flag--co">Colombia</option>
                      <option value="ec" className="flag flag--ec">Ecuador</option>
                      <option value="fi" className="flag flag--fi">Finland</option>
                      <option value="fr" className="flag flag--fr">France</option>
                      <option value="de" className="flag flag--de">Germany</option>
                      <option value="hk" className="flag flag--hk">Hong Kong</option>
                      <option value="id" className="flag flag--id">Indonesia</option>
                      <option value="ie" className="flag flag--ie">Ireland</option>
                      <option value="it" className="flag flag--it">Italy</option>
                      <option value="jp" className="flag flag--jp">Japan</option>
                      <option value="kw" className="flag flag--kw">Kuwait</option>
                      <option value="lb" className="flag flag--lb">Lebanon</option>
                      <option value="li" className="flag flag--li">Liechtenstein</option>
                      <option value="lu" className="flag flag--lu">Luxembourg</option>
                      <option value="my" className="flag flag--my">Malaysia</option>
                      <option value="mx" className="flag flag--mx">Mexico</option>
                      <option value="nl" className="flag flag--nl">Netherlands</option>
                      <option value="nz" className="flag flag--nz">New Zealand</option>
                      <option value="no" className="flag flag--no">Norway</option>
                      <option value="om" className="flag flag--om">Oman</option>
                      <option value="pt" className="flag flag--pt">Portugal</option>
                      <option value="qa" className="flag flag--qa">Qatar</option>
                      <option value="ru" className="flag flag--ru">Russia</option>
                      <option value="sg" className="flag flag--sg">Singapore</option>
                      <option value="es" className="flag flag--es">Spain</option>
                      <option value="se" className="flag flag--se">Sweden</option>
                      <option value="ch" className="flag flag--ch">Switzerland</option>
                      <option value="tr" className="flag flag--tr">Turkey</option>
                      <option value="gb" className="flag flag--gb">United Kingdom</option>
                      <option value="ae" className="flag flag--ae">United Arab Emirates</option>
                      <option value="us" className="flag flag--us">United States</option>
                      <option value="ve" className="flag flag--ve">Venezuela</option>
                      <option value="sk" className="flag flag--sk">Slovakia</option>
                      <option value="tw" className="flag flag--tw">Taiwan</option>
                    </select>
                  </fieldset>
                  <fieldset className="form-group is-active">
                    <label htmlFor="routingWantCustom">i want</label>
                    <div className="js-Dropdown" id="custom-routingWantCustom">
                      <button className="js-Dropdown-title"></button>
                      <ul className="js-Dropdown-list">
                        <li data-value="https://www.zurich.de" data-index="0" className="is-selected"></li>
                        <li data-value="https://www.zurich.de/de-de/privatkunden" data-index="1">Products</li>
                        <li data-value="https://www.zurich.de/de-de/meine-zurich/anmelden" data-index="2">Customer
                          portal
                        </li>
                        <li data-value="https://www.zurich.de/de-de/meine-zurich/anmelden" data-index="3">Claims</li>
                        <li data-value="https://www.zurich.de/de-de/service/kundenservice/kontaktwege"
                            data-index="4">Contact us
                        </li>
                        <li data-value="https://www.zurich.de/de-de/ueber-uns/ihre-karriere" data-index="5">Careers</li>
                        <li data-value="https://www.zurich.de/de-de/zurich-sports" data-index="6">Sports</li>
                      </ul>
                    </div>
                    <select id="routingWantCustom" className="custom-select" style={dispNone}>
                      <option value="https://www.zurich.de" data-placeholder="true"></option>


                      <option value="https://www.zurich.de/de-de/privatkunden">Products</option>
                      <option value="https://www.zurich.de/de-de/meine-zurich/anmelden">Customer portal</option>
                      <option value="https://www.zurich.de/de-de/meine-zurich/anmelden">Claims</option>
                      <option value="https://www.zurich.de/de-de/service/kundenservice/kontaktwege">Contact us</option>
                      <option value="https://www.zurich.de/de-de/ueber-uns/ihre-karriere">Careers</option>
                      <option value="https://www.zurich.de/de-de/zurich-sports">Sports</option>
                    </select>
                  </fieldset>
                  <fieldset className="routing-tool__cta">
                    <a href="#" className="btn btn--primary alt" data-track-prevent="">Visit country website<span
                        className="icon icon--share" aria-hidden="true"></span></a>
                  </fieldset>
                </form>
                {!props.single &&
                  <form className="routing-tool__form">
                  <h4 className="routing-tool__headline">
                    Please fill in for company support, claims or products
                  </h4>
                  <fieldset className="form-group is-active">
                    <label htmlFor="routingLocatedComany">i'm located in</label>
                    <div className="js-Dropdown" id="custom-routingLocatedComany">
                      <button className="js-Dropdown-title flag flag--de">Germany</button>
                      <ul className="js-Dropdown-list">
                        <li data-value="ar" data-index="0" className="flag flag--ar">Argentina</li>
                        <li data-value="au" data-index="1" className="flag flag--au">Australia</li>
                        <li data-value="at" data-index="2" className="flag flag--at">Austria</li>
                        <li data-value="bh" data-index="3" className="flag flag--bh">Kingdom of Bahrain</li>
                        <li data-value="be" data-index="4" className="flag flag--be">Belgium</li>
                        <li data-value="br" data-index="5" className="flag flag--br">Brazil</li>
                        <li data-value="ca" data-index="6" className="flag flag--ca">Canada</li>
                        <li data-value="cl" data-index="7" className="flag flag--cl">Chile</li>
                        <li data-value="cn" data-index="8" className="flag flag--cn">China</li>
                        <li data-value="co" data-index="9" className="flag flag--co">Colombia</li>
                        <li data-value="ec" data-index="10" className="flag flag--ec">Ecuador</li>
                        <li data-value="fi" data-index="11" className="flag flag--fi">Finland</li>
                        <li data-value="fr" data-index="12" className="flag flag--fr">France</li>
                        <li data-value="de" data-index="13" className="flag flag--de is-selected">Germany</li>
                        <li data-value="hk" data-index="14" className="flag flag--hk">Hong Kong</li>
                        <li data-value="id" data-index="15" className="flag flag--id">Indonesia</li>
                        <li data-value="ie" data-index="16" className="flag flag--ie">Ireland</li>
                        <li data-value="it" data-index="17" className="flag flag--it">Italy</li>
                        <li data-value="jp" data-index="18" className="flag flag--jp">Japan</li>
                        <li data-value="kw" data-index="19" className="flag flag--kw">Kuwait</li>
                        <li data-value="lb" data-index="20" className="flag flag--lb">Lebanon</li>
                        <li data-value="li" data-index="21" className="flag flag--li">Liechtenstein</li>
                        <li data-value="lu" data-index="22" className="flag flag--lu">Luxembourg</li>
                        <li data-value="my" data-index="23" className="flag flag--my">Malaysia</li>
                        <li data-value="mx" data-index="24" className="flag flag--mx">Mexico</li>
                        <li data-value="nl" data-index="25" className="flag flag--nl">Netherlands</li>
                        <li data-value="nz" data-index="26" className="flag flag--nz">New Zealand</li>
                        <li data-value="no" data-index="27" className="flag flag--no">Norway</li>
                        <li data-value="om" data-index="28" className="flag flag--om">Oman</li>
                        <li data-value="pt" data-index="29" className="flag flag--pt">Portugal</li>
                        <li data-value="qa" data-index="30" className="flag flag--qa">Qatar</li>
                        <li data-value="ru" data-index="31" className="flag flag--ru">Russia</li>
                        <li data-value="sg" data-index="32" className="flag flag--sg">Singapore</li>
                        <li data-value="es" data-index="33" className="flag flag--es">Spain</li>
                        <li data-value="se" data-index="34" className="flag flag--se">Sweden</li>
                        <li data-value="ch" data-index="35" className="flag flag--ch">Switzerland</li>
                        <li data-value="tr" data-index="36" className="flag flag--tr">Turkey</li>
                        <li data-value="gb" data-index="37" className="flag flag--gb">United Kingdom</li>
                        <li data-value="ae" data-index="38" className="flag flag--ae">United Arab Emirates</li>
                        <li data-value="us" data-index="39" className="flag flag--us">United States</li>
                        <li data-value="ve" data-index="40" className="flag flag--ve">Venezuela</li>
                        <li data-value="sk" data-index="41" className="flag flag--sk">Slovakia</li>
                        <li data-value="tw" data-index="42" className="flag flag--tw">Taiwan</li>
                      </ul>
                    </div>
                    <select id="routingLocatedComany" className="custom-select flag flag--de" style={dispNone}>

                      <option value="ar" className="flag flag--ar">Argentina</option>
                      <option value="au" className="flag flag--au">Australia</option>
                      <option value="at" className="flag flag--at">Austria</option>
                      <option value="bh" className="flag flag--bh">Kingdom of Bahrain</option>
                      <option value="be" className="flag flag--be">Belgium</option>
                      <option value="br" className="flag flag--br">Brazil</option>
                      <option value="ca" className="flag flag--ca">Canada</option>
                      <option value="cl" className="flag flag--cl">Chile</option>
                      <option value="cn" className="flag flag--cn">China</option>
                      <option value="co" className="flag flag--co">Colombia</option>
                      <option value="ec" className="flag flag--ec">Ecuador</option>
                      <option value="fi" className="flag flag--fi">Finland</option>
                      <option value="fr" className="flag flag--fr">France</option>
                      <option value="de" className="flag flag--de">Germany</option>
                      <option value="hk" className="flag flag--hk">Hong Kong</option>
                      <option value="id" className="flag flag--id">Indonesia</option>
                      <option value="ie" className="flag flag--ie">Ireland</option>
                      <option value="it" className="flag flag--it">Italy</option>
                      <option value="jp" className="flag flag--jp">Japan</option>
                      <option value="kw" className="flag flag--kw">Kuwait</option>
                      <option value="lb" className="flag flag--lb">Lebanon</option>
                      <option value="li" className="flag flag--li">Liechtenstein</option>
                      <option value="lu" className="flag flag--lu">Luxembourg</option>
                      <option value="my" className="flag flag--my">Malaysia</option>
                      <option value="mx" className="flag flag--mx">Mexico</option>
                      <option value="nl" className="flag flag--nl">Netherlands</option>
                      <option value="nz" className="flag flag--nz">New Zealand</option>
                      <option value="no" className="flag flag--no">Norway</option>
                      <option value="om" className="flag flag--om">Oman</option>
                      <option value="pt" className="flag flag--pt">Portugal</option>
                      <option value="qa" className="flag flag--qa">Qatar</option>
                      <option value="ru" className="flag flag--ru">Russia</option>
                      <option value="sg" className="flag flag--sg">Singapore</option>
                      <option value="es" className="flag flag--es">Spain</option>
                      <option value="se" className="flag flag--se">Sweden</option>
                      <option value="ch" className="flag flag--ch">Switzerland</option>
                      <option value="tr" className="flag flag--tr">Turkey</option>
                      <option value="gb" className="flag flag--gb">United Kingdom</option>
                      <option value="ae" className="flag flag--ae">United Arab Emirates</option>
                      <option value="us" className="flag flag--us">United States</option>
                      <option value="ve" className="flag flag--ve">Venezuela</option>
                      <option value="sk" className="flag flag--sk">Slovakia</option>
                      <option value="tw" className="flag flag--tw">Taiwan</option>
                    </select>
                  </fieldset>
                  <fieldset className="form-group is-active">
                    <label htmlFor="routingWantCompany">i want</label>
                    <div className="js-Dropdown" id="custom-routingWantCompany">
                      <button className="js-Dropdown-title"></button>
                      <ul className="js-Dropdown-list">
                        <li data-value="https://www.zurich.de" data-index="0" className="is-selected"></li>
                        <li data-value="https://www.zurich.de/de-de/geschaeftskunden" data-index="1">Products</li>
                        <li data-value="https://www.zurich.de/de-de/ueber-uns/kontakt" data-index="2">Contact us</li>
                      </ul>
                    </div>
                    <select id="routingWantCompany" className="custom-select" style={dispNone}>
                      <option value="https://www.zurich.de" data-placeholder="true"></option>


                      <option value="https://www.zurich.de/de-de/geschaeftskunden">Products</option>
                      <option value="https://www.zurich.de/de-de/ueber-uns/kontakt">Contact us</option>
                    </select>
                  </fieldset>
                  <fieldset className="routing-tool__cta">
                    <a href="#" className="btn btn--primary alt" data-track-prevent="">Visit country website<span
                      className="icon icon--share" aria-hidden="true"></span></a>
                  </fieldset>
                </form>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

routingToolMarkup.propTypes = {
  swap: PropTypes.bool,
  theme: PropTypes.string
}

export default routingToolMarkup;



// WEBPACK FOOTER //
// ./catalog/routingTool/routingTool-markup.js